import { render, staticRenderFns } from "./ShopType.vue?vue&type=template&id=b2371618&scoped=true"
import script from "./ShopType.vue?vue&type=script&lang=js"
export * from "./ShopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2371618",
  null
  
)

export default component.exports